import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CarouselNav = ({ direction, disabled, onClick, classes }) => {
    const isLeft = direction === 'left';

    return (
        <button
            type="button"
            className={isLeft ? classes.navLeft : classes.navRight}
            disabled={disabled}
            onClick={onClick}
        >
            <Icon name={isLeft ? 'chevronLeft' : 'chevronRight'} size="large" color="white" />
        </button>
    );
};

CarouselNav.propTypes = {
    direction: PropTypes.oneOf(['left', 'right']).isRequired,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default memo(CarouselNav);
